import React, { useState, useEffect } from 'react';
import { Clock, Wifi } from 'lucide-react';
import { getTokenTimeRemaining } from '../utils/auth';
import './SessionStatus.css';

const SessionStatus = ({ user }) => {
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    if (!user) return;

    const updateTimeRemaining = () => {
      const token = localStorage.getItem('token');
      if (token) {
        const remaining = getTokenTimeRemaining(token);
        setTimeRemaining(remaining);
        console.log('Session time remaining:', formatTime(remaining)); // Debug log
      }
    };

    // Update immediately
    updateTimeRemaining();

    // Update every 30 seconds for more responsive display
    const interval = setInterval(updateTimeRemaining, 30000);

    return () => clearInterval(interval);
  }, [user]);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const formatTime = (ms) => {
    const minutes = Math.floor(ms / (1000 * 60));
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours > 0) {
      return `${hours}h ${remainingMinutes}m`;
    }
    return `${remainingMinutes}m`;
  };
  const getStatusColor = () => {
    const minutesRemaining = timeRemaining / (1000 * 60);
    if (minutesRemaining < 5) return '#ff6b6b'; // Bright red
    if (minutesRemaining < 15) return '#ffa500'; // Orange
    return '#90ee90'; // Light green - better contrast on dark background
  };

  if (!user) {
    console.log('SessionStatus: No user provided'); // Debug log
    return null;
  }

  console.log('SessionStatus: Rendering with time:', formatTime(timeRemaining)); // Debug log

  return (
    <div className="session-status">
      <div className="session-time" style={{ color: getStatusColor() }}>
        <Clock size={14} />
        <span>{formatTime(timeRemaining)}</span>
      </div>
      
      <div className={`connection-status ${isOnline ? 'online' : 'offline'}`}>
        <Wifi size={14} />
      </div>
    </div>
  );
};

export default SessionStatus;
